<i class="icon" [ngClass]="{'disabled': !canUndo}" (click)="undo()">undo</i>
<i class="icon" [ngClass]="{'disabled': !canRedo}" (click)="redo()">redo</i>
